/**
 * Mock data pre finančné inštitúcie
 */

import { countryIds, municipalityIds } from "./officials";

const generateDate = (yearsAgo, monthOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - yearsAgo);
  date.setMonth(date.getMonth() + monthOffset);
  return date.toISOString();
};

const generateFutureDate = (yearsAhead, monthOffset = 0) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + yearsAhead);
  date.setMonth(date.getMonth() + monthOffset);
  return date.toISOString();
};

export const financialInstitutions = [
  {
    id: "fi-001",
    name: "Česká spořitelna, a.s.",
    username: "csas_bank",
    ic: "45244782",
    databox: "wx6dkif",
    created: generateDate(8),
    email: "csas@csas.cz",
    phone: "+420956777111",
    contactPerson: "Jan Banka",
    contactPersonDetail: {
      firstName: "Jan",
      lastName: "Banka",
      email: "jan.banka@csas.cz",
      phone: "+420956777222",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Olbrachtova",
      orientationNumber: "1929/62",
      zip: "14000",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(8),
    accountValidityTo: generateFutureDate(2),
  },
  {
    id: "fi-002",
    name: "Komerční banka, a.s.",
    username: "kb_bank",
    ic: "45317054",
    databox: "p5t2u2m",
    created: generateDate(7),
    email: "info@kb.cz",
    phone: "+420955559222",
    contactPerson: "Marie Úvěrová",
    contactPersonDetail: {
      firstName: "Marie",
      lastName: "Úvěrová",
      email: "marie.uverova@kb.cz",
      phone: "+420955559333",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Na Příkopě",
      orientationNumber: "33",
      zip: "11407",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(7),
    accountValidityTo: generateFutureDate(3),
  },
  {
    id: "fi-003",
    name: "ČSOB, a.s.",
    username: "csob_bank",
    ic: "00001350",
    databox: "8qvdk23",
    created: generateDate(6),
    email: "info@csob.cz",
    phone: "+420224111111",
    contactPerson: "Petr Finanční",
    contactPersonDetail: {
      firstName: "Petr",
      lastName: "Finanční",
      email: "petr.financni@csob.cz",
      phone: "+420224111222",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Radlická",
      orientationNumber: "333/150",
      zip: "15057",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(6),
    accountValidityTo: generateFutureDate(4),
  },
  {
    id: "fi-004",
    name: "UniCredit Bank Czech Republic and Slovakia, a.s.",
    username: "unicredit_bank",
    ic: "64948242",
    databox: "u3cj9w8",
    created: generateDate(5),
    email: "info@unicreditgroup.cz",
    phone: "+420221112111",
    contactPerson: "Eva Kreditová",
    contactPersonDetail: {
      firstName: "Eva",
      lastName: "Kreditová",
      email: "eva.kreditova@unicreditgroup.cz",
      phone: "+420221112222",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Želetavská",
      orientationNumber: "1525/1",
      zip: "14092",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(5),
    accountValidityTo: generateFutureDate(5),
  },
  {
    id: "fi-005",
    name: "Raiffeisenbank a.s.",
    username: "rb_bank",
    ic: "49240901",
    databox: "fq3jz6q",
    created: generateDate(4),
    email: "info@rb.cz",
    phone: "+420412446446",
    contactPerson: "Tomáš Sporitel",
    contactPersonDetail: {
      firstName: "Tomáš",
      lastName: "Sporitel",
      email: "tomas.sporitel@rb.cz",
      phone: "+420412446447",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Hvězdova",
      orientationNumber: "1716/2b",
      zip: "14078",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(4),
    accountValidityTo: generateFutureDate(6),
  },
  {
    id: "fi-006",
    name: "Hypoteční banka, a.s.",
    username: "hypobanka",
    ic: "13584324",
    databox: "2b6gdt2",
    created: generateDate(3),
    email: "info@hypotecnibanka.cz",
    phone: "+420800112211",
    contactPerson: "Lucie Hypotéková",
    contactPersonDetail: {
      firstName: "Lucie",
      lastName: "Hypotéková",
      email: "lucie.hypotekova@hypotecnibanka.cz",
      phone: "+420800112212",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Radlická",
      orientationNumber: "333/150",
      zip: "15057",
    },
    active: true,
    type: "MORTGAGE_BANK",
    accountValidityFrom: generateDate(3),
    accountValidityTo: generateFutureDate(7),
  },
  {
    id: "fi-007",
    name: "mBank S.A.",
    username: "mbank_cz",
    ic: "27943445",
    databox: "mb3k5t2",
    created: generateDate(5, 6),
    email: "info@mbank.cz",
    phone: "+420222111888",
    contactPerson: "Ondřej Mobilní",
    contactPersonDetail: {
      firstName: "Ondřej",
      lastName: "Mobilní",
      email: "ondrej.mobilni@mbank.cz",
      phone: "+420222111889",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Sokolovská",
      orientationNumber: "668/136d",
      zip: "18600",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(5, 6),
    accountValidityTo: generateFutureDate(4, 6),
  },
  {
    id: "fi-008",
    name: "Fio banka, a.s.",
    username: "fio_bank",
    ic: "61858374",
    databox: "fio123x",
    created: generateDate(6, 3),
    email: "info@fio.cz",
    phone: "+420224346111",
    contactPerson: "Jakub Investiční",
    contactPersonDetail: {
      firstName: "Jakub",
      lastName: "Investiční",
      email: "jakub.investicni@fio.cz",
      phone: "+420224346112",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "V Celnici",
      orientationNumber: "1028/10",
      zip: "11721",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(6, 3),
    accountValidityTo: generateFutureDate(3, 9),
  },
  {
    id: "fi-009",
    name: "Air Bank a.s.",
    username: "airbank_cz",
    ic: "29045371",
    databox: "air5b3k",
    created: generateDate(4, 2),
    email: "info@airbank.cz",
    phone: "+420222999111",
    contactPerson: "Tereza Digitální",
    contactPersonDetail: {
      firstName: "Tereza",
      lastName: "Digitální",
      email: "tereza.digitalni@airbank.cz",
      phone: "+420222999112",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Hráského",
      orientationNumber: "2231/25",
      zip: "14800",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(4, 2),
    accountValidityTo: generateFutureDate(5, 10),
  },
  {
    id: "fi-010",
    name: "Equa bank a.s.",
    username: "equabank",
    ic: "47116102",
    databox: "eqa7k2m",
    created: generateDate(5, 8),
    email: "info@equabank.cz",
    phone: "+420222010101",
    contactPerson: "Martin Flexibilní",
    contactPersonDetail: {
      firstName: "Martin",
      lastName: "Flexibilní",
      email: "martin.flexibilni@equabank.cz",
      phone: "+420222010102",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Karolinská",
      orientationNumber: "661/4",
      zip: "18600",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(5, 8),
    accountValidityTo: generateFutureDate(4, 4),
  },
  {
    id: "fi-011",
    name: "MONETA Money Bank, a.s.",
    username: "moneta_bank",
    ic: "25672720",
    databox: "mon8x5p",
    created: generateDate(3, 5),
    email: "info@moneta.cz",
    phone: "+420224444111",
    contactPerson: "Kateřina Peněžní",
    contactPersonDetail: {
      firstName: "Kateřina",
      lastName: "Peněžní",
      email: "katerina.penezni@moneta.cz",
      phone: "+420224444112",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Vyskočilova",
      orientationNumber: "1442/1b",
      zip: "14000",
    },
    active: true,
    type: "BANK",
    accountValidityFrom: generateDate(3, 5),
    accountValidityTo: generateFutureDate(6, 7),
  },
  {
    id: "fi-012",
    name: "Česká národní banka",
    username: "cnb_admin",
    ic: "48136450",
    databox: "cnb1234",
    created: generateDate(10),
    email: "podatelna@cnb.cz",
    phone: "+420224411111",
    contactPerson: "Aleš Regulační",
    contactPersonDetail: {
      firstName: "Aleš",
      lastName: "Regulační",
      email: "ales.regulacni@cnb.cz",
      phone: "+420224411112",
    },
    address: {
      country: { id: countryIds.czechRepublic, name: "Česká republika" },
      municipality: { id: municipalityIds.praha, name: "Praha" },
      municipalityId: municipalityIds.praha,
      street: "Na Příkopě",
      orientationNumber: "28",
      zip: "11503",
    },
    active: true,
    type: "CENTRAL_BANK",
    accountValidityFrom: generateDate(10),
    accountValidityTo: generateFutureDate(10),
  },
];

export default financialInstitutions;
